import React, { useEffect, useState } from 'react';
import '../../App.css';
import { LEGAL_META, POLICY_TABS, GRIEVANCE_ROWS } from '../../core/legal-policies';
import { isPoliciesPath, policiesUrl } from '../../core/app-routes';
import { InlineIcon } from '../../components/Icon';

function PolicySection({ section }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 8, color: 'var(--navy)' }}>{section.title}</h3>
      {section.body && <p style={{ marginBottom: section.bullets?.length ? 10 : 0, whiteSpace: 'pre-wrap' }}>{section.body}</p>}
      {section.bullets?.length > 0 && (
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {section.bullets.map((b, i) => (
            <li key={i} style={{ marginBottom: 8 }}>{b}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

function PolicyPage({ onBack, initialTab }) {
  const [tab, setTab] = useState(initialTab || 'terms');
  const active = POLICY_TABS.find(t => t.id === tab) || POLICY_TABS[0];

  useEffect(() => {
    if (initialTab) setTab(initialTab);
  }, [initialTab]);

  useEffect(() => {
    if (!isPoliciesPath()) return;
    const url = policiesUrl(tab);
    if (window.location.pathname + window.location.search !== url) {
      try { window.history.replaceState({}, '', url); } catch (_) { /* ignore */ }
    }
  }, [tab]);

  useEffect(() => {
    const label = tab === 'contact' ? 'Contact & Grievance' : active.label;
    document.title = `${label} — ${LEGAL_META.brand}`;
    return () => { document.title = 'Founders Bridge — Legal & Compliance Portal'; };
  }, [tab, active.label]);

  return (
    <div className="policy-page">
      <header className="policy-page-head">
        {onBack && (
          <button type="button" className="policy-page-back" onClick={onBack}>
            <InlineIcon name="back" size={13} gap={5}>Back</InlineIcon>
          </button>
        )}
        <div className="policy-page-title">{LEGAL_META.entity}</div>
      </header>

      <div className="policy-page-body">
        <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 20, textAlign: 'center' }}>
          <div style={{ marginBottom: 6 }}>
            {POLICY_TABS.map((t, i) => (
              <span key={t.id}>
                {i > 0 && ' · '}
                <button type="button" onClick={() => setTab(t.id)} style={{ background: 'none', border: 'none', padding: 0, color: tab === t.id ? 'var(--blue)' : 'var(--muted)', cursor: 'pointer', fontWeight: tab === t.id ? 700 : 400, textDecoration: tab === t.id ? 'underline' : 'none' }}>
                  {t.label}
                </button>
              </span>
            ))}
          </div>
          <div>{LEGAL_META.email} · {LEGAL_META.phone}</div>
          <div>{LEGAL_META.address}</div>
          <div style={{ marginTop: 6 }}>
            Effective date: {LEGAL_META.effectiveDate} · Last updated: {LEGAL_META.lastUpdated}
          </div>
        </div>

        <div className="tabs" style={{ marginBottom: 24, flexWrap: 'wrap' }}>
          {POLICY_TABS.map(t => (
            <div key={t.id} className={`tab ${tab === t.id ? 'on' : ''}`} onClick={() => setTab(t.id)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && setTab(t.id)}>
              {t.label}
            </div>
          ))}
          <div className={`tab ${tab === 'contact' ? 'on' : ''}`} onClick={() => setTab('contact')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && setTab('contact')}>
            Contact & Grievance
          </div>
        </div>

        {tab !== 'contact' ? (
          <div className="card">
            <div className="card-head">
              <div className="card-title">{active.label}</div>
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>Last updated: {LEGAL_META.lastUpdated}</div>
            </div>
            <div className="card-body" style={{ lineHeight: 1.8, fontSize: 14, color: 'var(--ink2)' }}>
              {active.intro && <p style={{ marginBottom: 24, whiteSpace: 'pre-wrap' }}>{active.intro}</p>}
              {active.sections.map(s => <PolicySection key={s.title} section={s} />)}
            </div>
          </div>
        ) : (
          <div className="card">
            <div className="card-head">
              <div className="card-title">Grievance Redressal & Contact</div>
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>Section 5</div>
            </div>
            <div className="card-body" style={{ lineHeight: 1.8, fontSize: 14, color: 'var(--ink2)' }}>
              <p style={{ marginBottom: 20 }}>
                In accordance with the Information Technology Act, 2000 and the rules thereunder, and the Consumer Protection (E-Commerce) Rules, 2020, the contact details for any grievance regarding the Website, Services or your personal information are set out below. We aim to acknowledge grievances within a reasonable time and resolve them expeditiously.
              </p>
              <div className="tbl-wrap">
                <table>
                  <tbody>
                    {GRIEVANCE_ROWS.map(([label, val]) => (
                      <tr key={label}>
                        <td style={{ fontWeight: 600, width: '38%', verticalAlign: 'top', padding: '10px 12px' }}>{label}</td>
                        <td style={{ padding: '10px 12px' }}>{val}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        <p style={{ marginTop: 28, fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, textAlign: 'center' }}>
          By using the Website or engaging our Services, you acknowledge that you have read and understood these Legal Policies — the Terms of Service, Privacy Policy, Refund & Cancellation Policy and Disclaimer — and agree to be bound by them.
        </p>
      </div>
    </div>
  );
}

export { PolicyPage };
